import { SafeHtml } from '../../../../../node_modules/@angular/platform-browser';
import { Url } from 'url';
import { PromoType } from './promoType';

export interface Gift {
    cantidad: number;
    classes: string;
    estadoCodigo: number;
    estadoDescripcion: string;
    estadoNombre: string;
    estadoIcono: string;
    estadoBoton: string;
    esPunto: boolean;
    fechaDesde: Date;
    fechaHasta: Date;
    fechaMaximaCanjeo: Date;
    fechaMaximaSeleccion: Date;
    disponibleCanjeo: boolean;
    fechaDesdeStr: string;
    fechaHastaStr: string;
    fechaMaximaCanjeoStr: string;
    fechaMaximaSeleccionStr: string;
    desripcionHtml: SafeHtml;
    idPromo: number;
    nombrePuntosConseguidos: string;
    promoConseguida: SafeHtml;
    puntos: number;
    regalos: Array<GiftOption>;
    regalosClon: Array<GiftOption>;
    tipoPromo: PromoType;
    titulo: SafeHtml;
    urlBanner: Url;
    urlIcono: Url;
    urlImagen: Url;
    urlLista: Url;
    urlRegalo: Url;
    tipoVista: string;
    descargas: Array<any>;
    hasIncident: boolean;
    incidents: Array<any>;
    giftDownload: boolean;
    notificationDate: Date;
    notificationId: number;
    notificationText: SafeHtml;
    buttonLabel: string;
    buttonTooltip: string;
    buttonTooltipBgClass: string;
    buttonTooltipArrowClass: string;
    pdfRegalo: string;
}

export interface GiftOption {
    id: number;
    idOrig?: number;
    imagen: string;
    nombre: string;
    nombreRegalo?: string;
    nombreOpciones: string;
    precio: number;
    opciones?: Array<string>;
    descarga: string;
    html: SafeHtml;
    cantidades: Array<any>;
}
export class GiftOptionHelper {
    static create(): GiftOption {
        return {
            id: undefined,
            idOrig: undefined,
            imagen: undefined,
            nombre: undefined,
            nombreRegalo: undefined,
            nombreOpciones: undefined,
            precio: undefined,
            opciones: undefined,
            descarga: undefined,
            html: undefined,
            cantidades: [],
        };
    }

    static transformFromApi(apiData: Object) {
        const giftOption = GiftOptionHelper.create();

        giftOption.id = apiData['ID'];
        giftOption.idOrig = apiData['ID'];
        giftOption.imagen = apiData['IMAGEN'];
        giftOption.nombre = apiData['NOMBRE'];
        giftOption.nombreRegalo = apiData['NOMBRE'];
        giftOption.nombreOpciones = apiData['NOMBRE_OPCIONES'];
        giftOption.precio = apiData['PRECIO'];
        giftOption.opciones = apiData['OPCIONES'] !== '' ? apiData['OPCIONES'].split(',') : [];
        giftOption.descarga = apiData['DESCARGA'];
        giftOption.html = apiData['HTML'];

        return giftOption;
    }
}

export interface GiftDescarga {
    id: number;
    descripcion: SafeHtml;
    enlace: string;
    codigo: string;
    fechaDescarga: Date;
    fechaDescargaStr: string;
}

export class GiftDescargaHelper {
    static create(): GiftDescarga {
        return {
            id: undefined,
            descripcion: undefined,
            enlace: undefined,
            codigo: undefined,
            fechaDescarga: new Date('1970-01-01'),
            fechaDescargaStr: undefined,
        };
    }

    static transformFromApi(apiData: Object) {
        const giftDescarga = GiftDescargaHelper.create();

        const anyoD = Number((apiData['FECHA_DESCARGA'] + '').toString().substring(0, 4));
        const mesD = Number((apiData['FECHA_DESCARGA'] + '').toString().substring(4, 6));
        const diaD = Number((apiData['FECHA_DESCARGA'] + '').toString().substring(6, 8));

        giftDescarga.id = apiData['ID'];
        giftDescarga.descripcion = apiData['DESCRIPCION'];
        giftDescarga.enlace = apiData['ENLACE'];
        giftDescarga.codigo = apiData['CODIGO'];

        if (apiData['FECHA_DESCARGA']) {
            giftDescarga.fechaDescarga = new Date(anyoD, mesD, diaD);
            // giftDescarga.fechaDescargaStr = diaD+'/'+mesD+'/'+anyoD;
            giftDescarga.fechaDescargaStr = apiData['FECHA_DESCARGA'];
        }

        return giftDescarga;
    }
}

export class GiftHelper {
    static create(): Gift {
        return {
            cantidad: undefined,
            classes: undefined,
            estadoCodigo: undefined,
            estadoDescripcion: undefined,
            estadoNombre: undefined,
            estadoIcono: undefined,
            estadoBoton: undefined,
            esPunto: false,
            fechaDesde: new Date('1970-01-01'),
            fechaHasta: new Date('1970-01-01'),
            fechaMaximaCanjeo: undefined,
            fechaMaximaSeleccion: undefined,
            disponibleCanjeo: true,
            fechaDesdeStr: undefined,
            fechaHastaStr: undefined,
            fechaMaximaCanjeoStr: undefined,
            fechaMaximaSeleccionStr: undefined,
            desripcionHtml: undefined,
            idPromo: undefined,
            nombrePuntosConseguidos: undefined,
            promoConseguida: undefined,
            puntos: undefined,
            regalos: [],
            regalosClon: [],
            tipoPromo: undefined,
            titulo: undefined,
            urlBanner: undefined,
            urlIcono: undefined,
            urlImagen: undefined,
            urlLista: undefined,
            urlRegalo: undefined,
            tipoVista: undefined,
            descargas: [],
            hasIncident: false,
            incidents: [],
            giftDownload: false,
            notificationDate: new Date('1970-01-01'),
            notificationId: undefined,
            notificationText: undefined,
            buttonLabel: '',
            buttonTooltip: '',
            buttonTooltipBgClass: '',
            buttonTooltipArrowClass: '',
            pdfRegalo: '',
        };
    }

    static getIcono(codigo: number): string {
        let ret = '';
        switch (codigo) {
            case 10:
                ret = 'refresh';
                break;
            case -1:
                ret = 'info_outline';
                break;
            case 20:
                ret = 'arrow_forward';
                break;
            case 0:
            case 30:
                ret = 'refresh';
                break;
            case 40:
            case 50:
            case 100:
                ret = 'check';
                break;
            default:
        }
        return ret;
    }

    static getTooltipBgClassByIcon(icon: string): string {
        switch (icon) {
            case 'refresh':
                return 'bg-info';
            case 'info_outline':
                return 'bg-warning-light';
            case 'arrow_forward':
            case 'check':
            default:
                return 'bg-success-light';
        }
    }

    static getTooltipArrowClassByIcon(icon: string): string {
        switch (icon) {
            case 'refresh':
                return 'fill-info';
            case 'info_outline':
                return 'fill-warning-light';
            case 'arrow_forward':
            case 'check':
            default:
                return 'fill-success-light';
        }
    }

    static getButtonColor(codigo: number): string {
        let ret = 'secondary';

        switch (codigo) {
            case 30:
                ret = 'naranja';
                break;
            case 40:
                ret = 'primary';
                break;
            case 50:
                ret = 'secondary';
                break;
        }

        return ret;
    }

    static getButtonClasses(gift: Gift): string {
        const classes = [];
        const expired = [-1, 30, 40, 50].includes(gift.estadoCodigo) && !gift.disponibleCanjeo;
        // Clase base para el botón
        if ([-1, 40, 50].includes(gift.estadoCodigo)) {
            classes.push('text-white hover:border-primary');
            if (!expired) {
                classes.push('hover:bg-white');
            }
        }

        // Lógica para bg-secondary y border-secondary
        if (![0, 10, 20].includes(gift?.estadoCodigo) && !expired && gift.estadoCodigo !== 100) {
            classes.push('bg-' + gift.estadoBoton + ' border-' + gift.estadoBoton);
        }

        // Lógica para text-primary y cursor-not-allowed
        if ([0, 10, 20].includes(gift?.estadoCodigo)) {
            classes.push('text-primary cursor-not-allowed opacity-75');
        }

        if (expired && ![40, 50].includes(gift?.estadoCodigo)) {
            classes.push('cursor-not-allowed opacity-75');
        }

        // Lógica para hover:text-primary y hover:border-primary
        if ((![-1, 30, 40, 50].includes(gift.estadoCodigo) || gift.disponibleCanjeo) && gift.estadoCodigo != 100) {
            classes.push('hover:text-primary hover:border-primary');
        }

        if (gift.estadoCodigo === 100) {
            classes.push(
                'bg-secondary border-secondary text-white hover:bg-secondary hover:border-secondary cursor-not-allowed hover:text-white'
            );
        }

        // Lógica para bg-tertiary y estados relacionados
        if (expired) {
            classes.push(
                'bg-tertiary hover:bg-tertiary border-warning-light text-warning-light hover:border-warning-light hover:text-warning-light'
            );
        }

        return classes.join(' ');
    }

    static getButtonLabel(gift: Gift): string {
        let ret = '';
        if ([-1, 30, 40, 50].indexOf(gift.estadoCodigo) !== -1 && !gift.disponibleCanjeo) {
            ret = 'gifts_expired';
        } else if (gift.estadoCodigo == 10 && gift.tipoVista === 'DESCARGA') {
            ret = 'gifts_10_2_btn';
        } else {
            ret = 'gifts_' + gift.estadoCodigo + '_btn';
        }
        return ret;
    }

    static getButtonTooltip(gift: Gift): string {
        if ([-1, 30, 40, 50].indexOf(gift.estadoCodigo) !== -1 && !gift.disponibleCanjeo) return '';

        if (gift.estadoCodigo === -1) {
            return 'gifts_tooltip_OPCIONES_-1'; //Elige una de las opciones y te lo haremos llegar.
        } else if (gift.estadoCodigo === 10) {
            if (gift.tipoVista == 'REGALOS')
                return 'gifts_tooltip_REGALOS_10'; //Pronto tendrá disponible su regalo, lo estamos preparando para envío.
            else return 'gifts_tooltip_available_soon';
        } else if (gift.estadoCodigo === 100) {
            return 'gifts_tooltip_REGALOS_100'; //Su regalo ha salido de nuestras instalaciones.
        } else if (gift.estadoCodigo === 10) {
            return 'gifts_tooltip_available_soon'; //Pronto tendrá disponibles tarjetas digitales para su descarga.
        } else if (gift.estadoCodigo === 40) {
            return 'gifts_tooltip_DESCARGA_100'; //Nuevas tarjetas disponibles de descarga
        } else if (gift.estadoCodigo === 50) {
            return 'gifts_tooltip_DESCARGA_50'; //Las tarjetas digitales han sido descargadas
        } else if (gift.estadoCodigo === -1) {
            return 'gifts_tooltip_OPCIONES_-1'; //Elige una de las opciones y te lo haremos llegar.
        } else {
            return 'gifts_tooltip_available_soon';
        }
    }

    static transformFromApi(apiData: Object) {
        const gift = GiftHelper.create();

        const anyoDesde = Number((apiData['FECHADESDE'] + '').toString().substring(0, 4));
        const mesDesde = Number((apiData['FECHADESDE'] + '').toString().substring(4, 6));
        const diaDesde = Number((apiData['FECHADESDE'] + '').toString().substring(6, 8));

        const anyoHasta = Number((apiData['FECHAHASTA'] + '').toString().substring(0, 4));
        const mesHasta = Number((apiData['FECHAHASTA'] + '').toString().substring(4, 6));
        const diaHasta = Number((apiData['FECHAHASTA'] + '').toString().substring(6, 8));

        const anyoMax = Number((apiData['FECHA_MAXIMA_CANJEO'] + '').toString().substring(0, 4));
        const mesMax = Number((apiData['FECHA_MAXIMA_CANJEO'] + '').toString().substring(4, 6));
        const diaMax = Number((apiData['FECHA_MAXIMA_CANJEO'] + '').toString().substring(6, 8));

        const anyoNotif = Number((apiData['NOTIFICACION_CREACION'] + '').toString().substring(0, 4));
        const mesNotif = Number((apiData['NOTIFICACION_CREACION'] + '').toString().substring(4, 6));
        const diaNotif = Number((apiData['NOTIFICACION_CREACION'] + '').toString().substring(6, 8));

        gift.cantidad = Number(apiData['CANTIDAD']);
        gift.idPromo = apiData['IDPROMO'];
        gift.estadoCodigo = apiData['ESTADO_CODIGO'];
        gift.estadoIcono = GiftHelper.getIcono(gift.estadoCodigo);
        gift.buttonTooltipBgClass = GiftHelper.getTooltipBgClassByIcon(gift.estadoIcono);
        gift.buttonTooltipArrowClass = GiftHelper.getTooltipArrowClassByIcon(gift.estadoIcono);
        gift.estadoBoton = GiftHelper.getButtonColor(gift.estadoCodigo);
        gift.estadoDescripcion = apiData['ESTADO_DESCRIPCION'];
        gift.estadoNombre = apiData['ESTADO_NOMBRE'];

        gift.esPunto = apiData['ES_PUNTO'] ? true : false;

        if (apiData['FECHADESDE']) {
            gift.fechaDesde = new Date(anyoDesde, mesDesde - 1, diaDesde);
            gift.fechaDesdeStr = diaDesde + '/' + mesDesde + '/' + anyoDesde;
        }

        if (apiData['FECHAHASTA']) {
            gift.fechaHasta = new Date(anyoHasta, mesHasta - 1, diaHasta);
            gift.fechaHastaStr = diaHasta + '/' + mesHasta + '/' + anyoHasta;
        }

        if (apiData['FECHA_MAXIMA_CANJEO']) {
            gift.fechaMaximaCanjeo = new Date(anyoMax, mesMax - 1, diaMax);
            gift.fechaMaximaCanjeoStr = diaMax + '/' + mesMax + '/' + anyoMax;
            gift.disponibleCanjeo = gift.fechaMaximaCanjeo > new Date();
        }
        if (apiData['FECHA_MAXIMA_SELECCION']) {
            const anyoMaxSel = Number((apiData['FECHA_MAXIMA_SELECCION'] + '').toString().substring(0, 4));
            const mesMaxSel = Number((apiData['FECHA_MAXIMA_SELECCION'] + '').toString().substring(4, 6));
            const diaMaxSel = Number((apiData['FECHA_MAXIMA_SELECCION'] + '').toString().substring(6, 8));
            gift.fechaMaximaSeleccion = new Date(anyoMaxSel, mesMaxSel - 1, diaMaxSel);
            gift.fechaMaximaSeleccionStr = diaMaxSel + '/' + mesMaxSel + '/' + anyoMaxSel;
            gift.disponibleCanjeo = gift.disponibleCanjeo && gift.fechaMaximaSeleccion > new Date();
        }

        // si ha habido descarga (50) y la fecha de selección ha finalizado se mira la fecha maxima de canjeo para el disponibleCanjeo
        if (
            (gift.estadoCodigo === 50 || gift.estadoCodigo === 40) &&
            gift.fechaMaximaSeleccion &&
            gift.fechaMaximaSeleccion < new Date() &&
            gift.fechaMaximaCanjeo
        ) {
            gift.disponibleCanjeo = gift.fechaMaximaCanjeo > new Date();
        }

        if (apiData['NOTIFICACION_CREACION']) {
            gift.notificationDate = new Date(anyoNotif, mesNotif - 1, diaNotif);
        }

        gift.desripcionHtml = apiData['HTML_DESCRIPCION'];
        gift.nombrePuntosConseguidos = apiData['NOMBRE_PUNTOS_CONSEGUIDOS'];
        gift.promoConseguida = apiData['PROMO_CONSEGUIDA'];
        gift.puntos = apiData['PUNTOS'];

        // REGALOS
        const cleanJson = apiData['REGALOS'] ? '[' + apiData['REGALOS'] + ']' : '[]';
        const regalosCollection = JSON.parse(cleanJson);

        const items = regalosCollection.map((regalo) => {
            return GiftOptionHelper.transformFromApi(regalo);
        });

        gift.regalos = items;

        // DESCARGAS
        const cleanJsonD = apiData['DESCARGAS'] ? '[' + apiData['DESCARGAS'] + ']' : '[]';
        const descargasCollection = JSON.parse(cleanJsonD);

        const itemsD = descargasCollection.map((descarga) => {
            return GiftDescargaHelper.transformFromApi(descarga);
        });

        gift.descargas = itemsD;

        gift.tipoPromo = apiData['TIPOPROMO'];
        gift.titulo = apiData['TITULO'];
        gift.urlBanner = apiData['URL_BANNER'];
        gift.urlIcono = apiData['URL_ICONO'];
        gift.urlImagen = apiData['URL_IMAGEN'];
        gift.urlLista = apiData['URL_LISTA'];
        gift.urlRegalo = apiData['URL_REGALO'];

        gift.tipoVista = apiData['TIPO_VISTA'];
        gift.giftDownload = apiData['REGALO_DESCARGA'] ? true : false;

        gift.notificationId = apiData['NOTIFICACION_ID'];
        gift.notificationText = apiData['NOTIFICACION_TEXTO'];

        const puntos = Number(gift.puntos);
        switch (gift.tipoVista) {
            case 'OPCIONES':
                const regalo = gift.regalos[0];
                const opciones = regalo.opciones;

                let cont: number = 1;
                opciones.map((it) => {
                    const op: GiftOption = GiftOptionHelper.create();
                    op.id = Number(regalo.id + cont);
                    op.idOrig = Number(regalo.id);
                    op.nombre = it;
                    op.nombreRegalo = regalo.nombre;
                    op.precio = regalo.precio;

                    gift.regalosClon.push(op);
                    cont++;
                });

                gift.regalosClon.map((item) => {
                    if (item.precio > 0) {
                        const puntosRegalo = Number(item.precio);
                        const cociente = puntos / puntosRegalo;

                        for (let i = 1; i <= Math.trunc(cociente); i++) {
                            item.cantidades.push(i);
                        }
                    } else {
                        console.error('Regalo sin precio (idPromo) => ' + gift.idPromo + ' (idOrig) => ' + item.idOrig);
                    }
                });
                break;
            case 'REGALOS':
                gift.regalos.map((item) => {
                    if (item.precio > 0) {
                        const puntosRegalo = Number(item.precio);
                        const cociente = puntos / puntosRegalo;

                        for (let i = 1; i <= Math.trunc(cociente); i++) {
                            item.cantidades.push(i);
                        }
                    } else {
                        console.error('Regalo sin precio (idPromo) => ' + gift.idPromo + ' (idOrig) => ' + item.idOrig);
                    }
                });

                break;
            case 'DESCARGAS':
                break;
        }

        gift.buttonLabel = GiftHelper.getButtonLabel(gift);
        gift.buttonTooltip = GiftHelper.getButtonTooltip(gift);
        gift.classes = GiftHelper.getButtonClasses(gift);
        gift.pdfRegalo = apiData['PDF_REGALO'];
        return gift;
    }
}
